import { useRecoilState } from "recoil";
import {
  bannerState,
  bannerLoadingState,
  bannerFetchedState,
} from "atoms/bannerAtom";
import { getBanners } from "apis/site";

export const useBanner = () => {
  const [banners, setBanners] = useRecoilState(bannerState);
  const [loading, setLoading] = useRecoilState(bannerLoadingState);
  const [fetched, setFetched] = useRecoilState(bannerFetchedState);

  const fetchBanners = async () => {
    if (fetched || loading) return; // 이미 호출했거나 로딩 중이면 다시 호출하지 않음

    setLoading(true);
    try {
      const data = await getBanners();
      console.log("getBanners");
      setBanners(data);
      setFetched(true); // 호출 완료 표시
    } catch (error) {
      console.error("배너 데이터를 가져오는데 실패했습니다:", error);
      setFetched(true); // 에러가 발생해도 호출 시도는 완료된 것으로 표시
    } finally {
      setLoading(false);
    }
  };

  const getBannersByCategory = (category: string) => {
    return banners.filter((banner) => banner.category === category);
  };

  return {
    banners,
    loading,
    fetchBanners,
    getBannersByCategory,
  };
};
